import React from "react";

const START = 150; // graus (inferior esquerdo) -> sentido horario ate 30 graus (inferior direito)
const SWEEP = 240;
const R = 100;
const C = 120;

const pt = (deg) => {
  const rad = (deg * Math.PI) / 180;
  return [C + R * Math.cos(rad), C + R * Math.sin(rad)];
};
const arc = (from, to) => {
  const [x1, y1] = pt(from);
  const [x2, y2] = pt(to);
  return `M ${x1} ${y1} A ${R} ${R} 0 ${to - from > 180 ? 1 : 0} 1 ${x2} ${y2}`;
};

// Indicador proporcional ao score real (0..max). Cor vem da classificacao do backend.
export const ScoreGauge = ({ score, max = 1000, color }) => {
  const ratio = Math.max(0, Math.min(1, Number(score || 0) / max));
  const end = START + SWEEP * ratio;
  const [kx, ky] = pt(end);
  return (
    <div className="relative mx-auto w-full max-w-[300px]" data-testid="portal-score-gauge" data-ratio={ratio.toFixed(3)}>
      <svg viewBox="0 0 240 205" className="w-full" role="img" aria-label={`Score ${score} de ${max}`}>
        <defs>
          <linearGradient id="gaugeFill" x1="0" y1="1" x2="1" y2="0">
            <stop offset="0" stopColor={color} stopOpacity="0.95" />
            <stop offset="1" stopColor={color} stopOpacity="0.55" />
          </linearGradient>
        </defs>
        <path d={arc(START, START + SWEEP)} fill="none" stroke="#EEE8F5" strokeWidth="18" strokeLinecap="round" />
        {ratio > 0 && <path d={arc(START, end)} fill="none" stroke="url(#gaugeFill)" strokeWidth="18" strokeLinecap="round" />}
        <circle cx={kx} cy={ky} r="11" fill="#fff" stroke={color} strokeWidth="4" />
      </svg>
      <div className="absolute inset-x-0 top-[34%] text-center">
        <div className="text-[56px] font-extrabold leading-none tabular-nums text-[#1E0B3D]" data-testid="portal-score-value">{score}</div>
        <div className="mt-1 text-[20px] text-[#4A3A63]">/ {max}</div>
      </div>
    </div>
  );
};
